import { FooterCloud } from '~components/Footers/FooterCloud/FooterCloud';
import { FooterCommon } from '~components/Footers/FooterCommon/FooterCommon';
import { FooterHrTek } from '~components/Footers/FooterHrTek/FooterHrTek';
import { HeaderCloud } from '~components/Headers/HeaderCloud/HeaderCloud';
import { HeaderCommon } from '~components/Headers/HeaderCommon/HeaderCommon';
import { HeaderHrTek } from '~components/Headers/HeaderHrTek/HeaderHrTek';
import { DeployEnvironments } from '~deploy-config/enviroments';

const headerComponents = {
  [DeployEnvironments.HRTek]: HeaderHrTek,
  [DeployEnvironments.VkCloudKz]: HeaderCloud,
  [DeployEnvironments.VkCloudRu]: HeaderCloud,
  [DeployEnvironments.Workspace]: HeaderCommon,
  [DeployEnvironments.Tarantool]: HeaderCommon,
  [DeployEnvironments.Finops]: HeaderCommon,
  [DeployEnvironments.Tech]: HeaderCommon,
} as const;

const footerComponents = {
  [DeployEnvironments.HRTek]: FooterHrTek,
  [DeployEnvironments.VkCloudKz]: FooterCloud,
  [DeployEnvironments.VkCloudRu]: FooterCloud,
  [DeployEnvironments.Workspace]: FooterCommon,
  [DeployEnvironments.Tarantool]: FooterCommon,
  [DeployEnvironments.Finops]: FooterCommon,
  [DeployEnvironments.Tech]: FooterCommon,
} as const;

export const PageUtils = {
  getHeaderComponent: (deployEnv: DeployEnvironments) =>
    headerComponents[deployEnv] || function () {},

  getFooterComponent: (deployEnv: DeployEnvironments) =>
    footerComponents[deployEnv] || function () {},
};
